/* tslint:disable */
/* eslint-disable */
/**
 * AS3.Portals
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CreateTransactionResponse,
  IdLogonByCprRequest,
  IdLogonByTransactionIdRequest,
  IdLogonByUsernamePasswordRequest,
  IdLogonCreateTransactionRequest,
  LogonResponse,
} from '../models/index';
import {
    CreateTransactionResponseFromJSON,
    CreateTransactionResponseToJSON,
    IdLogonByCprRequestFromJSON,
    IdLogonByCprRequestToJSON,
    IdLogonByTransactionIdRequestFromJSON,
    IdLogonByTransactionIdRequestToJSON,
    IdLogonByUsernamePasswordRequestFromJSON,
    IdLogonByUsernamePasswordRequestToJSON,
    IdLogonCreateTransactionRequestFromJSON,
    IdLogonCreateTransactionRequestToJSON,
    LogonResponseFromJSON,
    LogonResponseToJSON,
} from '../models/index';

export interface CreateTransactionRequest {
    idLogonCreateTransactionRequest?: IdLogonCreateTransactionRequest;
}

export interface LogonByCprRequest {
    idLogonByCprRequest?: IdLogonByCprRequest;
}

export interface LogonByTransactionRequest {
    idLogonByTransactionIdRequest?: IdLogonByTransactionIdRequest;
}

export interface LogonByUsernamePasswordRequest {
    idLogonByUsernamePasswordRequest?: IdLogonByUsernamePasswordRequest;
}

/**
 * 
 */
export class IdLogonApi extends runtime.BaseAPI {

    /**
     */
    async createTransactionRaw(requestParameters: CreateTransactionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateTransactionResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        const response = await this.request({
            path: `/umbraco/api/IdLogon/CreateTransaction`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IdLogonCreateTransactionRequestToJSON(requestParameters.idLogonCreateTransactionRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateTransactionResponseFromJSON(jsonValue));
    }

    /**
     */
    async createTransaction(requestParameters: CreateTransactionRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateTransactionResponse> {
        const response = await this.createTransactionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async logonByCprRaw(requestParameters: LogonByCprRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LogonResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        const response = await this.request({
            path: `/umbraco/api/IdLogon/LogonByCpr`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IdLogonByCprRequestToJSON(requestParameters.idLogonByCprRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LogonResponseFromJSON(jsonValue));
    }

    /**
     */
    async logonByCpr(requestParameters: LogonByCprRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LogonResponse> {
        const response = await this.logonByCprRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async logonByTransactionRaw(requestParameters: LogonByTransactionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LogonResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        const response = await this.request({
            path: `/umbraco/api/IdLogon/LogonByTransaction`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IdLogonByTransactionIdRequestToJSON(requestParameters.idLogonByTransactionIdRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LogonResponseFromJSON(jsonValue));
    }

    /**
     */
    async logonByTransaction(requestParameters: LogonByTransactionRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LogonResponse> {
        const response = await this.logonByTransactionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async logonByUsernamePasswordRaw(requestParameters: LogonByUsernamePasswordRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LogonResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        const response = await this.request({
            path: `/umbraco/api/IdLogon/LogonByUsernamePassword`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IdLogonByUsernamePasswordRequestToJSON(requestParameters.idLogonByUsernamePasswordRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LogonResponseFromJSON(jsonValue));
    }

    /**
     */
    async logonByUsernamePassword(requestParameters: LogonByUsernamePasswordRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LogonResponse> {
        const response = await this.logonByUsernamePasswordRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
